import React from 'react';
import { useTranslation } from "react-i18next";

const SuccessModal = ({ successMessage }) => {
    const { t } = useTranslation();
    return (
        <div style={styles.container}>
            <span style={styles.icon}>✅</span>
            <span style={styles.message}>{t(successMessage)}</span>
        </div>
    );
}

const styles = {
    container: {
        display: 'flex',
        alignItems: 'center',
        backgroundColor: '#d4edda',
        color: '#721c24',
        padding: '5px',
        border: '1px solid #c3e6cb',
    },
    icon: {
        marginRight: '10px',
        fontSize: '20px',
    },
    message: {
        fontSize: '16px',
    }
};

export default SuccessModal;
